import FlexCol from "../flex-col/flex-col.tsx";
import RaindropClickable from "../raindrop-clickable/raindrop-clickable.tsx";

import RaindropTextHeading2 from "../raindrop-text-heading-2/raindrop-text-heading-2.tsx";
import RaindropTextSubtitle from "../raindrop-text-subtitle/raindrop-text-subtitle.tsx";

const RaindropInfoBox = ({ title, value, onClick = () => {} }) => {
  let tailwindColor =
    "border-color-border-primary dark:border-color-dark-border-primary bg-color-border-primary dark:bg-color-dark-border-primary";

  return (
    <RaindropClickable onClick={onClick} additionalClasses="w-full">
      <div
        className={`flex flex-col items-center text-center justify-center border-4 border-t-[16px] rounded-lg  ${tailwindColor} w-full`}
      >
        <FlexCol
          className="dark:bg-color-dark-background-primary bg-color-background-primary rounded-lg p-4 "
          tailwindGap="gap-1"
        >
          <RaindropTextSubtitle>{title}</RaindropTextSubtitle>

          <RaindropTextHeading2>{value}</RaindropTextHeading2>
        </FlexCol>
      </div>
    </RaindropClickable>
  );
};

export default RaindropInfoBox;
